import { usePreference, preferenceNames } from './use-preference';

const ESTIMATION_API_SUPPORT_LOCALE = ['US', 'ES', 'FR', 'GE', 'IT', 'NE', 'SW', 'DE'];

export const useIsEstimationApiSupportedLocale = () => {
  const [{ value: countryPreference }] = usePreference(preferenceNames.SelectedCountry);

  if (countryPreference) {
    const locale = countryPreference.toUpperCase();
    return ESTIMATION_API_SUPPORT_LOCALE.includes(locale);
  }

  return false;
};
